import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const Prompt = makeShortcode("Prompt");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Sign in from the command line using security-key flow`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the `}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/cli/adduser"
          }}><inlineCode parentName="a">{`npm login`}</inlineCode></a>{` command.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted, provide your username, password, and email address.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`user@host:~$ npm login
npm notice Log in on https://registry.npmjs.org/
Username: mona
Password:
Email: (this IS public) mona@github.com
npm notice Open https://www.npmjs.com/login/913c3ab1-89a0-44bd-be8d-d946e2e906f0 to use your security key for authentication or enter OTP from your authenticator app
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you have configured a security-key, open the provided URL shown in the command line. Alternatively, if you have configured a mobile authenticator skip to step 6.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<em parentName="p">{`Use security key`}</em>{` and follow the browser specific steps to authenticate.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/2fa-use-security-key.png" alt="Screenshot showing security key prompt" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy the generated token`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/webauthn-cli-login-token.png" alt="Screenshot showing a sample token generated while using WebAuthn for cli login" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter the one-time password into the CLI prompt.`}</p>
        <Prompt mdxType="Prompt">Enter one-time password:</Prompt>
      </li>
    </ol>
    <h2>{`Sign in from the command line using `}<inlineCode parentName="h2">{`--auth-type=web`}</inlineCode></h2>
    <p>{`npm 8.14.0 and higher support login flow through the browers. This will become the default behavior for the npm public registry in npm 9.`}</p>
    <h3>{`With an existing browser session`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the `}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/cli/adduser"
          }}><inlineCode parentName="a">{`npm login --auth-type=web`}</inlineCode></a>{` command.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted hit "ENTER" to open your browser to start the login flow or click the provided URL show in the command line.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`user@host:~$ npm login
npm notice Log in on https://registry.npmjs.org/
Authenticate your account at:
https://www.npmjs.com/login?next=/login/cli/b1a2f96a-ce09-4463-954c-c99f6773b922
Press ENTER to open in the browser...
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<em parentName="p">{`Use security key`}</em>{`  and follow the browser specific steps to authenticate.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/2fa-use-security-key.png" alt="Screenshot showing security key prompt" mdxType="Screenshot" />
        <p parentName="li"><em parentName="p">{`Note: If you have configured to use TOTP, you will see an TOTP prompt instead`}</em></p>
      </li>
    </ol>
    <h3>{`Without an existing browser session`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, type the `}<a parentName="p" {...{
            "href": "https://docs.npmjs.com/cli/adduser"
          }}><inlineCode parentName="a">{`npm login --auth-type=web`}</inlineCode></a>{` command.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When prompted hit "ENTER" to open your browser to start the login flow or click the provided URL show in the command line.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`user@host:~$ npm login
npm notice Log in on https://registry.npmjs.org/
Authenticate your account at:
https://www.npmjs.com/login?next=/login/cli/b1a2f96a-ce09-4463-954c-c99f6773b922
Press ENTER to open in the browser...
`}</code></pre>
      </li>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<em parentName="p">{`Use security key`}</em>{`  and follow the browser specific steps to authenticate.`}</p>
        <Screenshot src="/getting-started/setting-up-your-npm-user-account/2fa-use-security-key.png" alt="Screenshot showing security key prompt" mdxType="Screenshot" />
        <p parentName="li"><em parentName="p">{`Note: If you have configured to use TOTP, you will see an TOTP prompt instead`}</em></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      